<template>
  <div>
    <div class="loading" v-if="loading">
      <md-progress-spinner class="md-accent" :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
    </div>
    <div class="loading" v-if="!loading && errorMessage !== null">
      {{errorMessage}}
    </div>
    <div class="loading" v-if="!loading && errorMessage === null">

      <md-card>
        <md-card-header>
          <div class="md-title">Courses</div>
        </md-card-header>

        <md-card-content>
          <md-table>

            <md-table-row v-if="courseList && courseList.length > 0">
              <md-table-head md-sort-name="name">Name</md-table-head>
              <md-table-head>Activities</md-table-head>
              <md-table-head>Color</md-table-head>
            </md-table-row>

            <md-table-row v-for="object in courseList" :key="object.versionedId.id" >
              <md-table-cell>{{object.name}}</md-table-cell>

              <md-table-cell>{{object.activities.length}}</md-table-cell>


              <md-table-cell>
                <span v-if="object.color && object.color !== 'DEFAULT'">
                  <md-icon class="md-size-2x" :style="'color: ' + object.color">style</md-icon>
                </span>
              </md-table-cell>

              <md-table-cell>
                <md-button class="md-icon-button md-dense md-primary editButton" :to="'course/' + object.versionedId.id" >
                  <md-icon class="md-morph-final">edit</md-icon>
                </md-button>
                <span>
                  <md-icon style="margin-top: 4px;" v-if="!object.edit && isSoftLocked(object.versionedId.id)" class="md-morph-final"><md-tooltip md-direction="bottom">{{getLockedByString(object.versionedId.id)}}</md-tooltip>warning</md-icon>
                </span>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions>
          <md-button class="md-primary md-raised" @click="copyPromptActive = true">Copy Course</md-button>
          <md-button class="md-primary md-raised" @click="showNewObjectDialog">New Course</md-button>
        </md-card-actions>
      </md-card>

    </div>

    <md-dialog :md-active.sync="createPromptActive">
      <md-dialog-title>Create a new course</md-dialog-title>

      <div class="dialogContent">
        <md-field >
          <label>Name</label>
          <md-input v-focus ref="newObjectFirstField" v-model="newObject.name" @keyup.enter="createObject" @keyup.esc="createPromptActive = false"></md-input>
        </md-field>
        <md-field>
          <swatches v-model="newObject.color" :colors="colors" inline show-border></swatches>
          <!--<span class="md-helper-text">Color2</span>-->
        </md-field>
        <md-dialog-actions>
          <md-button class="md-primary" @click="createPromptActive = false">Cancel</md-button>
          <md-button class="md-primary md-raised" @click="createObject" v-bind:disabled="!dialogCreateActive">Create</md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>

    <md-dialog :md-active.sync="copyPromptActive">
      <md-dialog-title>Copy Course</md-dialog-title>

      <div class="dialogContent">
        <md-field>
          <label>Course</label>
          <md-select v-model="courseIdToCopy" md-dense>
            <md-optgroup v-for="city in courseTemplates" :key="city.name" :label="city.name">
              <md-option v-for="course in city.courses" :key="course.versionedId.id" :value="course.versionedId.id">{{course.name}} ({{course.activities.length}})</md-option>
            </md-optgroup>
          </md-select>
        </md-field>

        <md-dialog-actions>
          <md-button class="md-primary" @click="copyPromptActive = false">Cancel</md-button>
          <md-button class="md-primary md-raised" @click="copyCourse" v-bind:disabled="!dialogCopyActive">Copy</md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>

  </div>
</template>

<script>
  import Swatches from 'vue-swatches'

  var nameCompareIgnoreCase = function(a, b) {
    var nameA = a.name.toUpperCase(); // ignore upper and lowercase
    var nameB = b.name.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // names must be equal
    return 0;
  };

  export default {
    components: {Swatches},
    name: "Courses",
    data() {
      var mutableFields = ['name', 'color'];
      return {
        loading: false,
        errorMessage: null,
        createPromptActive: false,
        newObject: {
          name: '',
          color: 'DEFAULT'
        },
        mutableFields: mutableFields,
        copyPromptActive: false,
        courseIdToCopy: null,
        courseTemplates: [],
        // https://github.com/saintplay/vue-swatches/blob/master/src/presets/material-dark.js
        colors: [
          'DEFAULT',
          '#D32F2F',
          '#C2185B',
          '#7B1FA2',
          '#512DA8',
          '#303F9F',
          '#1976D2',
          '#0288D1',
          '#0097A7',
          '#00796B',
          '#388E3C',
          '#689F38',
          '#AFB42B',
          '#FBC02D',
          '#FFA000',
          '#F57C00',
          '#E64A19',
          '#5D4037',
          '#616161',
          '#455A64'
        ]
      }
    },
    computed: {
      courseList() {
        if (this.$store.state.currentCityDetails) {
          this.loading = false;
          return this.$store.state.currentCityDetails.courses;
        } else {
          return [];
        }
      },
      dialogCreateActive() {
        var active = true;
        this.mutableFields.forEach(fieldName => {
          if (this.newObject[fieldName].length < 1) {
            active = false;
          }
        });
        return active;
      },
      dialogCopyActive() {
        return this.courseIdToCopy !== null && this.courseIdToCopy.length > 0;
      }
    },
    methods: {
      isSoftLocked(lockId) {
        return (this.$store.state.otherUserPageLocks[lockId] !== undefined)
      },
      getLockedByString(lockId) {
        if (this.$store.state.otherUserPageLocks[lockId] !== undefined) {
          return Object.keys(this.$store.state.otherUserPageLocks[lockId]).join(', ');
        } else {
          return "";
        }
      },
      showNewObjectDialog() {
        this.newObject = {
          name: '',
          color: 'DEFAULT'
        };
        this.createPromptActive = true;
        var refs = this.$refs; setTimeout(() => this.$nextTick(() => refs.newObjectFirstField.$el.focus()), 300);
      },
      createObject() {
        this.createPromptActive = false;
        this.$store.api.rpcRequest('createCourse', {
          name: this.newObject.name,
          cityId: this.$store.state.currentCity.versionedId.id,
          color: this.newObject.color
        }, newObject => {
          this.$router.push('course/' + newObject.versionedId.id);
        }, errorMessage => {
          this.createPromptActive = true;
        });
      },
      copyCourse() {
        this.copyPromptActive = false;
        this.$store.api.rpcRequest('copyCourse', {
          cityId: this.$store.state.currentCity.versionedId.id,
          courseIdToCopy: this.courseIdToCopy
        }, newObject => {
          this.$router.push('course/' + newObject.versionedId.id);
        }, errorMessage => {
          this.copyPromptActive = true;
        });
      }
    },
    created() {
      this.$store.api.rpcRequest('getCoursesToCopy', {}, courses => {
        var courseTemplates = [];
        if (courses.GLOBAL && courses.GLOBAL.length > 0) {
          courseTemplates.push({
            name: "Global",
            courses: courses.GLOBAL.sort(nameCompareIgnoreCase)
          })
        }
        Object.keys(courses).sort().forEach(cityName => {
          if (courses[cityName].length > 0 && cityName !== "GLOBAL") {
            courseTemplates.push({
              name: cityName,
              courses: courses[cityName].sort(nameCompareIgnoreCase)
            })
          }
        });
        this.courseTemplates = courseTemplates;
      }, errorMessage => {
      });
    }
  }
</script>

<style scoped>
  .dialogContent {
    padding: 24px;
  }

  .md-table-head {
    text-align: center;
  }

  button.editButton { visibility: hidden;}
  tr:hover button.editButton{ visibility: visible;}

  .md-dialog {
    z-index: 5;
  }

</style>



// WEBPACK FOOTER //
// src/components/city/Courses.vue